import { NgModule, inject } from '@angular/core';

import { IconsModule } from './icons/icons.module';
import { TranslocoCoreModule } from './transloco/transloco.module';
@NgModule({
  imports: [IconsModule, TranslocoCoreModule],
  providers: []
})
export class CoreModule {
  /**
   * Constructor
   */
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });
    // Do not allow multiple injections
    if (parentModule) {
      throw new Error(
        'CoreModule has already been loaded. Import this module in the AppModule only.'
      );
    }
  }
}
